import CourseNavigationLayout from "@/screens/CourseNavigationLayout.jsx";

export default function AmazonPage() {
  const navItems = [
    {
      path: "/course/amazon/lessons",
      value: "course",
      label: "Курсы",
      onProgress: false,
    },
    {
      path: "/course/amazon/products-list",
      value: "productList",
      label: "Список Товаров",
      onProgress: false,
    },
    {
      path: "/course/amazon/bonus",
      value: "bonusLessons",
      label: "Бонусные видеоуроки",
      onProgress: false,
    },
    {
      path: "/course/amazon/chat",
      value: "chats",
      label: "Чат с наставником",
      onProgress: false,
    },
    {
      path: "/course/amazon/ai",
      value: "ai",
      label: "ИИ чат",
      onProgress: false,
    },
    {
      path: "/course/amazon/invest",
      value: "invest",
      label: "Инвестор",
      onProgress: false,
    },
    {
      path: "/course/amazon/telegram",
      value: "telegram",
      label: "Телеграм канал",
      onProgress: false,
      externalLink: `https://t.me/orlandiya22`,
    },
  ];

  return <CourseNavigationLayout navItems={navItems} />;
}
